import { Record } from 'immutable';

const PropertySearchRequestRecord = Record({
  chain: null,
  brand: null,
  property: null,
  city: null,
  stateCode: null,
  countryCode: null,
  onlySubscribers: false
});

export class PropertySearchRequest extends PropertySearchRequestRecord {
  chain: string;
  brand: string;
  property: string;
  city: string;
  stateCode: string;
  countryCode: string;
  onlySubscribers: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/models/property-search-request.ts